var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blockquote',{staticClass:"blockquote"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum maiores modi quidem veniam, expedita quis laboriosam, ullam facere adipisci, iusto, voluptate sapiente corrupti asperiores rem nemo numquam fuga ab at.")])
}
var staticRenderFns = []

export { render, staticRenderFns }